import { InitialConfig } from "../models/common/common";
import { StyleSetup } from "../models/style";
import { initialStyleSetup } from "./style-config";

export const initConfig: InitialConfig = {
    logo: '/default.png',
    styles: initialStyleSetup as StyleSetup,
    club_code: ""
}